/*
  Internal files (comment attachments, styling session files, DHL's documents) open only through
  links the API signs for a few minutes (ALS-493, ADR 0104): `Assets:SignedLinkLifetime`, five
  minutes unless an environment says otherwise. That is the point, since a copied link dies with
  it, but it holds for this page too: a record left open for ten minutes would hold links that no
  longer open, and a click on one would answer 403 with no way back but a reload.

  So a query whose answer carries one is asked again every two minutes while its screen is open,
  and straight away when the tab is looked at again after being hidden, when the interval does not
  run. A link on screen is then always less than half its life old, and each refetch replaces it
  with one that runs from now. Whoever shortens the lifetime below about four minutes has to
  shorten this with it.
*/

export const SIGNED_LINK_REFRESH_MS = 2 * 60_000;

/** Spread into the options of a query whose answer carries a signed link. */
export const signedLinkRefresh = {
    staleTime: SIGNED_LINK_REFRESH_MS,
    refetchInterval: SIGNED_LINK_REFRESH_MS,
    refetchOnWindowFocus: true,
} as const;
